import React from "react";
import { Button, Card, Badge, Icon, Text, Box } from "~/components-shared";
import styled from "styled-components";
const CloseButton = styled(Button)`
  position: absolute;
  top: 1em;
  right: 1em;
`;
const StyledCard = styled(Card)`
  position: absolute;
  top: 1em;
  right: 1em;
`;
const Chip = styled.div`
  height: 5px;
  width: 8%;
  border-radius: 3px;
  background-image: ${_ref => {
  let {
    $bgImage,
    $active
  } = _ref;
  return $active ? $bgImage : "none";
}};
  background-color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.text.disabled;
}};
`;
const NodeDetails = _ref3 => {
  let {
    node,
    onClose
  } = _ref3;
  if (!node) return null;
  const getIcon = () => {
    switch (node.type) {
      case "source":
        return /*#__PURE__*/React.createElement(Icon, {
          scale: 7,
          color: "#ffffff",
          src: "webhook"
        });
      case "entity":
        return /*#__PURE__*/React.createElement(Icon, {
          scale: 7,
          color: "#ffffff",
          src: "sell"
        });
      default:
        return /*#__PURE__*/React.createElement(Icon, {
          scale: 7,
          color: "#ffffff",
          src: "trendingUp"
        });
    }
  };
  const getColor = () => {
    switch (node.type) {
      case "source":
        return "linear-gradient(135deg, hsl(199 89% 48%), hsl(217 91% 60%))";
      case "entity":
        return "linear-gradient(135deg, hsl(262 83% 58%), hsl(292 84% 61%))";
      default:
        return "linear-gradient(135deg, hsl(31 97% 62%), hsl(43 96% 56%))";
    }
  };
  return /*#__PURE__*/React.createElement(StyledCard, {
    s: {
      p: 4,
      mt: 24,
      ml: 11
    },
    width: "300px",
    color: "backgroundDark",
    shadow: true
  }, /*#__PURE__*/React.createElement(Box, {
    s: {
      mb: 4
    }
  }, /*#__PURE__*/React.createElement(Box, {
    gap: 3,
    direction: "row",
    wrap: "nowrap"
  }, /*#__PURE__*/React.createElement(Badge, {
    style: {
      backgroundImage: getColor()
    },
    s: {
      p: 2
    }
  }, getIcon()), /*#__PURE__*/React.createElement(Box, {
    s: {
      pr: 5
    },
    direction: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "bold"
  }, node.label), /*#__PURE__*/React.createElement(Text, {
    fontSize: 3,
    weight: "regular",
    color: "textSecondary"
  }, node.type.toUpperCase()))), /*#__PURE__*/React.createElement(CloseButton, {
    color: "transparent",
    s: {
      p: 2
    },
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "cross",
    display: "block"
  }))), /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    gap: 4
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3,
    weight: "bold",
    s: {
      mb: 1
    }
  }, "Subdomain"), /*#__PURE__*/React.createElement(Badge, {
    color: "translucent",
    s: {
      py: 0.5
    }
  }, node.subdomain)), /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3,
    weight: "bold",
    s: {
      mb: 1
    }
  }, "Intensity"), /*#__PURE__*/React.createElement(Box, {
    gap: 1,
    direction: "row",
    fullWidth: true
  }, Array.from({
    length: 10
  }).map((_, i) => /*#__PURE__*/React.createElement(Chip, {
    key: i,
    $bgImage: getColor(),
    $active: i < node.intensity
  })))), node.description && /*#__PURE__*/React.createElement(Box, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3,
    weight: "bold",
    s: {
      mb: 1
    }
  }, "Description"), /*#__PURE__*/React.createElement(Text, {
    display: "block"
  }, node.description)), node.sources && node.sources.length > 0 && /*#__PURE__*/React.createElement(Box, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3,
    weight: "bold",
    s: {
      mb: 1
    }
  }, "Data Sources"), /*#__PURE__*/React.createElement(Box, {
    gap: 1
  }, node.sources.map(source => /*#__PURE__*/React.createElement(Badge, {
    key: source,
    color: "translucent",
    s: {
      py: 0.5
    }
  }, source)))), node.relatedNodes && node.relatedNodes.length > 0 && /*#__PURE__*/React.createElement(Box, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3,
    weight: "bold",
    s: {
      mb: 1
    }
  }, "Related Nodes"), /*#__PURE__*/React.createElement(Box, {
    gap: 1
  }, node.relatedNodes.map(relatedNode => /*#__PURE__*/React.createElement(Badge, {
    key: relatedNode,
    color: "translucent",
    s: {
      py: 0.5
    },
    rounded: true
  }, relatedNode))))));
};
export default NodeDetails;